function initTimer() {
  const DURATION_MS = (1 * 60 + 58) * 60 * 1000; // 1h 58m
  const STORAGE_KEY = "acc-countdown-timer-end-time";

  function getEndTime() {
    const stored = Number(sessionStorage.getItem(STORAGE_KEY));
    const now = Date.now();
    return stored > now ? stored : resetEndTime();
  }

  function resetEndTime() {
    const end = Date.now() + DURATION_MS;
    sessionStorage.setItem(STORAGE_KEY, end);
    return end;
  }

  function updateTimeElements(hours, minutes, seconds) {
    const hoursEl = document.querySelector(".acc-countdown-timer-tile.hours_tile .acc-countdown-timer-time");
    const minutesEl = document.querySelector(".acc-countdown-timer-tile.minutes_tile .acc-countdown-timer-time");
    const secondsEl = document.querySelector(".acc-countdown-timer-tile.seconds_tile .acc-countdown-timer-time");

    if (hoursEl) hoursEl.textContent = String(hours).padStart(2, "0");
    if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, "0");
    if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, "0");
  }

  function startCountdown() {
    let endTime = getEndTime();

    function update() {
      const now = Date.now();
      let timeLeft = endTime - now;

      if (timeLeft <= 0) {
        endTime = resetEndTime();
        timeLeft = endTime - now;
      }

      const totalSeconds = Math.floor(timeLeft / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      updateTimeElements(hours, minutes, seconds);
    }

    update();
    setInterval(update, 1000);
  }

  startCountdown();
}

document.addEventListener("DOMContentLoaded", initTimer);
